module.exports = __webpack_public_path__ + "img/x-01.acec28a0.svg";